import React, { useCallback, useRef } from 'react'
import { useShop } from '../../../Providers/ShopProvider';

const useChangePageLastElementRef = () => {

    const observer = useRef();

    const {
        setPageNumber,
        loadingProducts,
        hasMore
    } = useShop();

    const lastBookElementRef = useCallback(node => {
        if (loadingProducts) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loadingProducts, hasMore])

    return { lastBookElementRef }
}

export default useChangePageLastElementRef